import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "btn-group col ms-1 pe-0",
    role: "group",
    style: _normalizeStyle({'max-width': (_ctx.filterValues.length * 120) + 'px'})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterValues, (value, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: value,
        type: "button",
        class: _normalizeClass(["btn btn-outline-secondary text-nowrap", { 'active': index === _ctx.selected }]),
        onClick: ($event: any) => (_ctx.onSelect(index))
      }, _toDisplayString(value), 11, _hoisted_1))
    }), 128))
  ], 4))
}